export const USER_ROLES = {
  USER: "user",
  ADMIN: "admin",
} as const;

export const USER_ROLE_LABELS: Record<
  (typeof USER_ROLES)[keyof typeof USER_ROLES],
  string
> = {
  [USER_ROLES.USER]: "Buchhalter",
  [USER_ROLES.ADMIN]: "Admin",
};
